<script setup lang="ts">
import type { HTMLAttributes, StyleValue } from 'vue'
import { computed } from 'vue'
import { cn } from '@/ui/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  pinned?: 'left' | 'right'
  pinnedOffset?: number
  pinnedWidth?: number
}>()

const pinnedStyle = computed<StyleValue>(() => {
  if (!props.pinned) return {}
  return {
    [props.pinned]: `${props.pinnedOffset ?? 0}px`,
    ...(props.pinnedWidth ? { width: `${props.pinnedWidth}px`, minWidth: `${props.pinnedWidth}px` } : {})
  }
})
</script>

<template>
  <th
    data-slot="table-head"
    :class="
      cn(
        'text-foreground h-12 px-2 text-left align-middle text-sm font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        pinned && 'sticky z-20 bg-muted',
        pinned === 'left' && 'border-r',
        pinned === 'right' && 'border-l',
        props.class
      )
    "
    :style="pinnedStyle"
  >
    <slot />
  </th>
</template>
